import { SessionFee } from '../appSlice';
import { numberToDollarFormat } from './utility';

export const calcSessionFeeMessage = (sessionFee: SessionFee) => {
    let message = '';
    if (sessionFee.percentage > 0) {
        message += `${sessionFee?.percentage * 100}%`;
    }
    if (sessionFee.percentage > 0 && sessionFee.fixed > 0) {
        message += ' + ';
    }
    if (sessionFee.fixed > 0) {
        message += `${numberToDollarFormat(sessionFee.fixed)}`;
    }
    if (message != '') {
        message = 'Session/activation fee: ' + message;
    }
    return message;
};

export const subtotalWithoutSessionFee = (
    total: number,
    sessionFee?: SessionFee | null
): number => {
    if (
        !sessionFee ||
        (sessionFee.percentage === 0 && sessionFee.fixed === 0)
    ) {
        return total;
    }
    if (sessionFee.percentage === 0) {
        return Math.max(0, total - sessionFee.fixed);
    }
    return Math.max(
        0,
        (total - sessionFee.fixed) / (1 + sessionFee.percentage)
    );
};

/** Live session cost never includes session/activation fee. */
export const resolveRunningChargeCost = (
    rawCost: number,
    sessionFee: SessionFee | null | undefined
): number => {
    return rawCost;
};
